module.exports = __webpack_public_path__ + "static/media/sun.6cc0208a.svg";